import './loading.view.css'

export const LoadingView = () => <div className='LoadingView' />
